import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-master',
  templateUrl: './landing-master.component.html',
  styleUrls: ['./landing-master.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LandingMasterComponent implements OnInit {

  constructor() {
    this.removeCssById("css_landing");
    this.loadStyle("assets/index/css/vendor/font-awesome.css");
    this.loadStyle("assets/index/css/vendor/slick.css");
    this.loadStyle("assets/index/css/vendor/slick-theme.css");
    this.loadStyle("assets/index/css/vendor/animate/animate.min.css");
    this.loadStyle("assets/index/app.css");
    this.loadScript("assets/index/app.js");
    this.loadScript("assets/index/js/slick.min.js");
   }
   mobile:any=false;
   medium:any=false;
  ngOnInit(): void {
    $("#preloader").show("slow");
    $(".logo_navbar").css("max-width","8% !important");
    
    this.preloader();
    setTimeout(()=>{
      let footer:any = document.getElementsByClassName("footer-section");      
      footer[0].style.display = "none";
    },2000);
    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
      if (window.screen.width > 668 && window.screen.width < 820) this.medium = true;
    }else {
      this.mobile = false;
    }
  }
  scrollToTop() {
    window.scrollTo({
      top: 0, // Défile jusqu'au haut de la page
      behavior: 'smooth' // Active le défilement fluide
    });
  }
  public loadScript(scripts:string) {
    let node = document.createElement("script");
    node.src = scripts;
    node.type = "text/javascript";
    node.async = true;
    node.defer;
    var scriptsTags = document.getElementsByTagName('script');
    for (var i = scriptsTags.length; i--;) {
        if (scriptsTags[i].src != scripts) {
          document.getElementsByTagName("body")[0].appendChild(node);
          // break;
        }else {
          break;
        }
    }
  }
  public loadStyle(link:string) {
    let node = document.createElement("link");
    node.href = link;
    node.type = "text/css";
    node.id = "css_landing";
    node.rel ="stylesheet";
    var linksTags = document.getElementsByTagName('link');
    for (var i = linksTags.length; i--;) {
        if (linksTags[i].href != link) {
          document.getElementsByTagName("head")[0].appendChild(node);
          // break;
        }else {
          break;
        }
    }
  }
  preloader () {
    setTimeout(function () {
      $("#preloader").hide("slow");
    }, 1500);
    setTimeout(function () {
      $(".footer-section").css("display","none !important")
    }, 5000);
  }
  removeCssById(id: string) {
    const styleElement = document.getElementById(id);
    if (styleElement) {
      styleElement.remove(); // Removes the element from the DOM
    } else {
      console.log(`No CSS found with id '${id}'`);
    }
  };

}
